module.exports = require("./vo.js");